import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidebar/sgds-sidebar-item";
import { register } from "../../utils/ce-registry";

register("sgds-sidebar-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidebar-item",
  elementClass: Component,
  events: {}
});
